export const appVersion = '1.19.0-rc.1';
